module.exports = __webpack_public_path__ + "static/media/38-7.71ea751d.mp3";